import React from "react";
import { MessageCircle } from "lucide-react";
import { SITE } from "../lib/api";

export default function WhatsappFab() {
  const url = `https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(
    "Olá Rosalvo, gostaria de falar com você."
  )}`;
  return (
    <a
      href={url}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-fab"
      aria-label="Falar no WhatsApp"
      className="wa-pulse fixed bottom-6 right-6 z-50 inline-flex items-center justify-center w-14 h-14 md:w-16 md:h-16 bg-[#25D366] text-white shadow-lg hover:scale-105 transition-transform"
    >
      <MessageCircle size={26} />
    </a>
  );
}
